import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { subDays } from 'date-fns';

import { Filters } from '../../interfaces/filters';
import { formatDateForApi } from '../../utils/dateUtils';

export const useFilters = (): Filters => {
    const [searchParams] = useSearchParams();

    const filters = useMemo((): Filters => {
        const parseNumber = (input?: string | null): number | null => {
            if (input === undefined || input === null) {
                return null;
            }

            const parsedInput = parseInt(input, 10);

            if (Number.isNaN(parsedInput)) {
                return null;
            }

            return parsedInput;
        };

        const earliestDeliveryDepartureTimestamp = searchParams.get('earliest_delivery_departure_timestamp');
        const latestDeliveryDepartureTimestamp = searchParams.get('latest_delivery_departure_timestamp');

        const carrierBusinessUnitCodes = searchParams.get('carrier_business_unit_codes');
        const commodityCodes = searchParams.get('commodity_codes');
        const pickupPartyIds = searchParams.get('pickup_party_ids');
        const deliveryPartyIds = searchParams.get('delivery_party_ids');
        const freightOrderSpecifiedEqptCodes = searchParams.get('freight_order_specified_eqpt_codes');

        const minimumRevenueUsdAmount = searchParams.get('minimum_revenue_usd_amount');
        const maximumRevenueUsdAmount = searchParams.get('maximum_revenue_usd_amount');

        return {
            earliest_delivery_departure_timestamp: earliestDeliveryDepartureTimestamp || formatDateForApi(subDays(new Date(), 7)),
            latest_delivery_departure_timestamp: latestDeliveryDepartureTimestamp || formatDateForApi(subDays(new Date(), 1)),
            carrier_business_unit_codes: carrierBusinessUnitCodes?.split(',') || [],
            freight_order_specified_eqpt_codes: freightOrderSpecifiedEqptCodes?.split(',') || [],
            pickup_party_ids: pickupPartyIds?.split(',') || [],
            delivery_party_ids: deliveryPartyIds?.split(',') || [],
            commodity_codes: commodityCodes?.split(',') || [],
            minimum_revenue_usd_amount: parseNumber(minimumRevenueUsdAmount),
            maximum_revenue_usd_amount: parseNumber(maximumRevenueUsdAmount),
            cleanse_data: false,
        };
    }, [searchParams]);

    return filters;
};
